module.exports = __webpack_public_path__ + "static/rug-b1c6313ff7cdff497bfb65a8beb46ce3.jpg";